import React from "react";
import Home from "../views/home";
import About from "../views/about";
import Pricing from "../views/pricing";
import Allies from "../views/allies";
import Resources from "../views/resources";
import { Route, Switch } from "react-router-dom";
import ChatBot from "../UI/chatbot";
import "./styles.css";
import ScrollMessage from "../UI/scroll-message";

function Mainview() {
  return (
    <div className="mainview">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/allies" component={Allies} />
        <Route exact path="/resources" component={Resources} />
      </Switch>

      <div className="mainview__box">
        <ScrollMessage />
        <ChatBot />
      </div>
    </div>
  );
}

export default Mainview;
